import InstagramVuejs  from '../assets/work-images/instagram-vuejs.JPG'
import TeslaReactjs  from '../assets/work-images/tesla-reactjs.JPG'
import SabayNewsReactjs from '../assets/work-images/sabaynews-reactjs.JPG'
import DisneyPlusFlutter from '../assets/work-images/disneyplus-flutter.JPG'
import FoodPandaFlutter from '../assets/work-images/foodpanda-flutter.JPG'
import MovieAppFlutter from '../assets/work-images/foodpanda-flutter.JPG'

export const MyWorkList = [
    {
        img: InstagramVuejs, 
        title: "Simple Instagram UI Clone with Vue.js", 
        link: "/"
    },
    {
        img: TeslaReactjs,
        title: "Tesla Clone React.js + Styled Components", 
        link: "/"
    },
    {
        img: SabayNewsReactjs,
        title: "Sabay News Clone with React.js", 
        link: "/"
    },
    {
        img: DisneyPlusFlutter,
        title: "DisneyPlus Clone with Flutter + Firebase Authenticaton", 
        link: "/"
    },
    {
        img: FoodPandaFlutter,
        title: "FoodPanda UI Clone with Flutter", 
        link: "/"
    },
    {
        img: MovieAppFlutter,
        title: "Movie App with Flutter MovieDB Api", 
        link: "/"
    },
]